import { Injectable } from "@angular/core";
import { PersistedStoreConfig } from '@persistence/persisted-store-config';
import { Topics } from "@common/interfaces/topics";
import { IID_OL_OLOREQUEST } from "@common/interfaces/interfaceData";
import { ID } from '@common/interfaces/id';
import { EntityState, EntityStore } from "@datorama/akita";
import { InterfaceDataStore } from '../interfaceDataRegistry';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';

export interface IIDolOloRequestState extends EntityState<IID_OL_OLOREQUEST, ID> { }

@Injectable({
  providedIn: 'root'
})
@PersistedStoreConfig({ name: Topics.IID_OL_OLO_REQUEST })
@InterfaceDataStore(InterfaceName.OLO_REQUEST)
export class IIDolOloRequestStore extends EntityStore<IIDolOloRequestState> {
  constructor() {
    super([]);
  }
}
